import React from "react";
import styled, { keyframes } from "styled-components";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import {
  isSubmissionOpen,
  SUBMISSION_ENDTIME,
} from "../../utils/tinkerpreneur";

const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.35; }
  100% { opacity: 1; }
`;

const Notice = styled.div`
  display: inline-block;
  border-radius: 5px;
  padding: 8px 16px;
  font-weight: bold;
  font-size: 1.25rem;
  background: linear-gradient(to right, #90ee90, #add8e6);
  animation: ${blink} 1.6s ease-in-out infinite;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

/**
 * Deadline-extension notice shown above the Tinkerpreneur banner.
 *
 * Follows the pattern of IndiaAIFestivalDeadlineNotice, with two differences:
 *
 *   - the date is derived from SUBMISSION_ENDTIME rather than passed in, so it
 *     cannot drift out of step with the window the rest of the page enforces;
 *   - the flashing is self-contained. The shared BlinkingNode passes its class as
 *     a prop instead of className, so it does not actually animate; using it here
 *     would render a static box, and fixing it would change the Dashboard and
 *     festival pages that also use it.
 *
 * Renders nothing once submissions close, so it retires itself.
 */
const ATLTinkerpreneurDeadlineNotice = ({ year }) => {
  const { t } = useTranslation();

  if (!isSubmissionOpen(year)) {
    return null;
  }

  const endTime = SUBMISSION_ENDTIME[year];
  const deadline = endTime
    ? moment(endTime).format("Do MMMM YYYY, h:mm A")
    : null;

  if (!deadline) {
    return null;
  }

  return (
    <div className="d-flex justify-content-center w-100 px-3">
      <Notice>
        <p className="mb-0 text-center">
          {t("tinkerpreneur_deadline_extended", { year, deadline })}
        </p>
      </Notice>
    </div>
  );
};

export default ATLTinkerpreneurDeadlineNotice;
